var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrong = function SvgWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.615 0 2.5 2.115.385 0 0 .385 2.115 2.5 0 4.615.385 5 2.5 2.885 4.615 5 5 4.615 2.885 2.5 5 .385 4.615 0Z",
    fill: "#F83726"
  })));
};
export { SvgWrong as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgNSA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC42MTUzOSAwTDIuNSAyLjExNTM4TDAuMzg0NjE2IDBMMCAwLjM4NDYxM0wyLjExNTM5IDIuNDk5OTlMOC42NDU1MWUtMDcgNC42MTUzOEwwLjM4NDYxNiA1TDIuNSAyLjg4NDYxTDQuNjE1MzkgNUw1IDQuNjE1MzhMMi44ODQ2MiAyLjQ5OTk5TDUgMC4zODQ2MTNMNC42MTUzOSAwWiIgZmlsbD0iI0Y4MzcyNiIvPgo8L3N2Zz4K";